import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "dw-popup" }
const _hoisted_2 = { class: "dw-popup__container" }
const _hoisted_3 = { class: "container__header" }
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.2929 10.2929C12.6834 9.90237 13.3166 9.90237 13.7071 10.2929L18 14.5858L22.2929 10.2929C22.6834 9.90237 23.3166 9.90237 23.7071 10.2929C24.0976 10.6834 24.0976 11.3166 23.7071 11.7071L19.4142 16L23.7071 20.2929C24.0976 20.6834 24.0976 21.3166 23.7071 21.7071C23.3166 22.0976 22.6834 22.0976 22.2929 21.7071L18 17.4142L13.7071 21.7071C13.3166 22.0976 12.6834 22.0976 12.2929 21.7071C11.9024 21.3166 11.9024 20.6834 12.2929 20.2929L16.5858 16L12.2929 11.7071C11.9024 11.3166 11.9024 10.6834 12.2929 10.2929Z",
  fill: "#64748B"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "container__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (_openBlock(), _createElementBlock("svg", {
          width: "36",
          height: "32",
          viewBox: "0 0 36 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
        }, _hoisted_6))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}